import i18n from '../../../i18n';
import {isEmpty, isInteger} from 'lodash';
import { isHour } from '../../../data/shared/validators';
import moment from 'moment'

export const validate = values => {
    let errors = {};

    date(values, errors);
    people(values, errors);
    journey(values, errors);

    return errors;
};

const date = (values, errors) => {
    if (isEmpty(values.date)) {
        return errors.date = i18n.t('booking.validation_date');
    }
    if (moment(values.date) <= moment().add(1, 'days')) {
        return errors.date = i18n.t('booking.validation_invalid_date');
    }
};

const hour = (values, errors) => {
    if (isEmpty(values.hour)) {
        return errors.hour = i18n.t('booking.validation_hour');
    }

    if (!isHour(values.hour)) {
        return errors.hour = i18n.t('booking.validation_hour_format');
    }
};


const from = (values, errors) => {
    if (!validateFromTo('from', values.from)) {
        errors.from = i18n.t('booking.validation_from');
    }
};

const to = (values, errors) => {
    if (!validateFromTo('to', values.to)) {
        errors.to = i18n.t('booking.validation_to');
    }
};

const people = (values, errors) => {
    let parsed = parseInt(values.people, 10)
    if (!isInteger(parsed) || parsed <= 0) {
        return errors.people = i18n.t('booking.validation_people_count');
    }
};

const price = (values, errors) => {
    if (isEmpty(values.price)) {
        return errors.price = i18n.t('booking.validation_price');
    }

    if (!isDecimal(values.price)) {
        return errors.price = i18n.t('booking.validation_price_format');
    }
}

const journey = (values, errors) => {
    let err = {};

    if (isEmpty(values.journey) || isEmpty(values.journey.departure)) {
        err = {
            ...err,
            departure: "D'où partez-vous ?"
        };
    }

    if (isEmpty(values.journey) || isEmpty(values.journey.arrival)) {
        err = {
            ...err,
            arrival: "Jusqu'où allez-vous ?"
        };
    }

    if (isEmpty(values.journey) || isEmpty(values.journey.time)) {
        err = {
            ...err,
            time: "Vous devez indiquer l'heure"
        };
    } else if (!isHour(values.journey.time)) {
        err = {
            ...err,
            time: "L'heure doit être au format hh:mm"
        };
    }

    if (!isEmpty(err)) {
        errors.journey = err;
    }
};
